import { Button } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import ConfirmationModalInterest from './modals/ConfirmationModalInterest';
import { IMAGE_BASE_URL } from '../../common/Constants';
import Noimage from "../../images/noimage.png";

const LongBankCard = (props) => {
  const InterestIndex = props.interestSort;
  const product = props.product;
  const index = props.indexData;
  const { setSelectedLoanDetails } = props.SelectedLoanDetails;
  const Interest = product.activeinterest;
  const remarkInterest = product.interests;
  const { selectedLoans, setselectedLoans } = props.loanContext;
  const [selectTog, setSelectTog] = useState(false);
  const [manualDisable, setManualDisable] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [interestChange, setInterestChange] = useState(false);
  const [interestChangeData, setInterestChangeData] = useState({});

  const [isExpanded, setIsExpanded] = useState(false);

  let startDate = Interest?.startDate
    ? dayjs(Interest?.startDate).format('DD MMM YYYY').toUpperCase()
    : null;
  let endDate = Interest?.endDate
    ? dayjs(Interest?.endDate).format('DD MMM YYYY').toUpperCase()
    : null;
  const handleAgentBonus = (e) => {
    e.preventDefault();
    const agentData = {
      name: product.name,
      icon: product.icon,
      startDate,
      endDate,
      interest: Interest?.interest,
    };
    // console.log('HANDLE PROPS', product);
    if (product?.bonuses && product?.bonuses.length > 0) {
      props.allAgentBonus(agentData, product?.bonuses);
    }
  };

  const cartUpdate = async (selectedLoans) => {
    const response = await ServerAPI.updateCart(selectedLoans);
    // console.log(response);
    let selectedItemsData = [];
    if (response != undefined && response.data) {
      let items = response.data.items;
      if (items != undefined && items.length > 0) {
        items.map((item) => {
          let itemData = { ...item.productinfo };
          itemData['activeinterest'] = item.interestinfo;
          itemData['check'] = true;
          selectedItemsData.push(itemData);
        });
        setSelectedLoanDetails(selectedItemsData);
      }
    }
  };
  const handleSelectLoan = (premium) => {

    console.log("disable========", product.hasPremium == 0, manualDisable, selectTog)

    let prevLoan = [...selectedLoans];
    // Check if the product id already exists in selectedLoans

    const index = prevLoan.findIndex((loan) => loan.product === product.id);

    const prodData = {
      product: product.id,
      interest: Interest.id,
      is_premium: premium == 1 ? 1 : 0,
      is_manual: premium == 0 ? 1 : 0,
      check: true,
    };

    if (index === -1) {
      // Product id doesn't exist, push the product into selectedLoans
      prevLoan.push(prodData);
      cartUpdate(prevLoan);
      setselectedLoans(prevLoan);
      setSelectTog(!selectTog);
    } else {
      let indexData = prevLoan.findIndex(
        (loan) =>
          loan.product === product.id &&
          loan?.interest != Interest.id &&
          !selectTog
      );
      if (indexData != -1) {
        setConfirmModal(true);
        let data = {
          interest: Interest.id,
          index: indexData,
        };
        setInterestChangeData(data);
      } else {
        setSelectTog(!selectTog);
        prevLoan.splice(index, 1);
        cartUpdate(prevLoan);
        setselectedLoans(prevLoan);
      }
      // Product id exists, remove the product from selectedLoans
    }
  };

  useEffect(() => {
    if (interestChange == true) {
      let selectedLoanDatas = [...selectedLoans];
      selectedLoanDatas[interestChangeData.index]['interest'] =
        interestChangeData.interest;
      setSelectTog(!selectTog);
      setselectedLoans(selectedLoanDatas);
      cartUpdate(selectedLoans);
    }
  }, [interestChange]);
  useEffect(() => {
    let manualProducts = selectedLoans.filter((loan) => loan.is_premium == 0);
    const selectedIndex = selectedLoans.findIndex(
      (loan) => loan.product === product.id && loan?.interest === Interest.id
    );
    if (selectedIndex !== -1) {
      setSelectTog(true);
    } else {
      setSelectTog(false);
    }
    if (selectedLoans.length === 0) {
      setSelectTog(false);
    }

    setManualDisable(manualProducts.length == 6 ? true : false);
  }, [selectedLoans]);

  // console.log('product', product);
  // console.log('remark', remarkInterest);
  // console.log('product?.interests?.remarks', product?.interests[0].remarks);
  const remarks = product?.interests?.[0]?.remarks || [];
  return (
    <div className={`rounded-[16px] bg-white w-full cus_shadow2 relative ${isExpanded ? "z-[9]" : "z-0"}`}>
      <div className='grid  sm:flex justify-between flex-wrap' >
        <div className="flex flex-wrap justify-between w-full h-[287px]">
          <div
            className={`flex flex-wrap justify-between w-full bg-white p-[16px_20px] rounded-[25px] rounded-[16px] bg-white w-full cus_shadow2 relative ${isExpanded ? "z-[9]" : "z-0"}`}
          >
            <div className="flex-1 w-[40%]">
              <div className="card_head relative flex items-center mb-[10px]">
                <div className="absolute top-[-33px] left-0 bg-white h-[58px] w-[58px] rounded-[8px]">
                  {/* <img
                src={`${IMAGE_BASE_URL}${product.icon}`}
                alt='Bank Logo'
                className='rounded-[8px]'
                width='58'
                height='58'
                style={{ maxWidth: '100%', height: 'auto' }}
              /> */}
                  <img
                    src={
                      product?.icon
                        ? `${IMAGE_BASE_URL}/${product.icon}`
                        : Noimage // ✅ Use fallback image if no avatar
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = Noimage; // ✅ Set fallback image on error
                    }}
                    alt="Bank Logo"
                    className="rounded-[8px]"
                    width="58"
                    height="58"
                    style={{ width: "auto", height: "40px", margin: "10px auto" }}
                  />
                </div>
                <span className='pl-[70px] font-[700]'>{product.name}</span>
                <span className='ml-[15px] flex gap-2 flex-wrap'>
                  {product.hasPremium ? (
                    <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]'>
                      <img
                        src='/images/prem_icon.svg'
                        className='w-[16px]'
                        alt='star'
                      />{' '}
                      <span className='relative top-[1px]'>Premium</span>
                    </span>
                  ) : null}
                  {product.featured ? (
                    <span className='inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]'>
                      <img src='/images/star.svg' className='w-[16px]' alt='star' />{' '}
                      <span className='relative top-[1px]'>Featured</span>
                    </span>
                  ) : null}
                </span>
              </div>

              <div className='text-[11px] text-[#787486] card_head'>
                <label className='block text-[#0D062D] text-[13px] font-bold mb-[6px]'>
                  Remarks
                </label>
                {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p> */}
                {/* {Array.isArray(product?.interests[0].remarks) &&
              product?.interests[0].remarks.map((item, idx) => (
                <p key={idx} className="mt-[2px]">
                  {item?.text ? item.text.length > 50 ? item.text.substring(0, 50) + "..." : item.text : ""}
                </p>
              ))} */}


                {/* {Array.isArray(product?.interests[0].remarks) && (
              <>
                <ul className="list-disc pl-4 space-y-[4px] m-0 transition-all duration-300 ease-in-out">
                  {(isExpanded ? Interest.remarks : Interest.remarks.slice(0, 3)).map((item, idx) => (
                    <li key={idx} className="text-[12px] text-black leading-[1.4]">
                      <span className={`block ${!isExpanded ? "truncate overflow-hidden whitespace-nowrap text-ellipsis" : ""}`}
                        title={item?.text || ""} >
                        {item?.text || ""}
                      </span>
                    </li>
                  ))}
                </ul>

                {Interest.remarks.length > 3 && (
                  <div className="text-center">
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsExpanded((prev) => !prev);
                      }}
                      className="text-blue-600 mt-1 inline-block cursor-pointer text-[13px] font-bold"
                    >
                      {isExpanded ? "Read less" : "See more"}
                    </span>

                  </div>
                )}
              </>
            )} */}

                {Array.isArray(product?.interests[0].remarks) && (
                  <>
                    <ul className="list-disc pl-4 space-y-[4px] m-0 transition-all duration-300 ease-in-out">
                      {(isExpanded ? remarks : remarks.slice(0, 3)).map((item, idx) => (
                        <li key={idx} className="text-[12px] text-black leading-[1.4]">
                          <span
                            className={`block ${!isExpanded ? "truncate overflow-hidden whitespace-nowrap text-ellipsis" : ""}`}
                            title={item?.text || ""}
                          >
                            {item?.text || ""}
                          </span>
                        </li>
                      ))}
                    </ul>
                    {remarks.length > 3 && (
                      <div className="text-center">
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsExpanded((prev) => !prev);
                          }}
                          className="text-blue-600 mt-1 inline-block cursor-pointer text-[13px] font-bold"
                        >
                          {isExpanded ? "Read less" : "See more"}
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>

              <div className='flex flex-wrap mt-[20px] gap-[15px]'>

                <div>
                  <p className='text-[12px] mb-[8px] flex items-center'>
                    <img
                      src='/images/fi_dollar.svg'
                      alt='calendar'
                      className='mr-[5px]'
                    />
                    Min. Loan:{' '}
                    <strong className='ml-[5px] font-[600]'>
                      {Interest?.minimum_loan_amount > 0
                        ? '$' + parseInt(Interest?.minimum_loan_amount)
                        : 'No min. loan required'}{' '}
                      {Interest?.admin_fee_status === '1' &&
                        `else + admin fee $${parseInt(Interest?.admin_fee)}`}
                    </strong>
                  </p>
                  <p className='text-[12px] mb-[8px] flex items-center'>
                    <img
                      src='/images/fi_calendar.svg'
                      alt='calendar'
                      className='mr-[5px]'
                    />
                    Available from:{' '}
                    <strong className='ml-[5px] font-[600]'>
                      {startDate}
                      <span className='mx-[6px]'>to</span>
                      {endDate ? endDate : 'Further Notice'}
                    </strong>
                  </p>
                  <div className='flex flex-wrap items-center justify-between gap-[5px_25px]'>
                    <p className='text-[12px] mb-[0] flex items-center'>
                      <img
                        src='/images/fi_clock.svg'
                        alt='calendar'
                        className='mr-[5px]'
                      />
                      Approval time:{' '}
                      <strong className='ml-[5px] font-[600]'>
                        {product?.approvaltimeinfo?.name}
                      </strong>
                    </p>
                    <p className='text-[12px] mb-[0] flex items-center'>
                      <img
                        src='/images/fi_zap.svg'
                        alt='calendar'
                        className='mr-[5px]'
                      />
                      Loan to Value:{' '}
                      <strong className='ml-[5px] font-[600]'>
                        {product?.ltvinfo?.name}
                      </strong>
                    </p>
                  </div>
                </div>


              </div>
            </div>



            <div className='text-left' style={{ width: "13%", marginLeft: "5%" }}>
              <div className='relative bottom-[7px] min-w-[90px]'>
                <div className='text-[26px] font-[800]'>
                  {Interest?.interest}%
                </div>
                {/* <div
                  className={`text-[13px] text-[#0F59F9] ${product?.bonuses.length ? 'cursor-pointer' : 'cursor-auto'
                    }`}
                  onClick={handleAgentBonus}
                >
                  Bonus ({product?.bonuses ? product?.bonuses?.length : `0`})
                </div> */}
              </div>


              <p className='text-[#787486] mb-[3px] text-[12px]'>
                Monthly Installment
              </p>
              <p className='text-[#0D062D] text-[20px] mb-[10px] font-[800]'>
                ${product?.monthly_installment}
              </p>
              {product?.is_rejected == 1 ? (
                <Button
                  type='primary'
                  size='large'
                  className={`loan_com_btn ${selectTog && 'active'}`}
                  disabled={true}
                >
                  Rejected
                </Button>
              ) : (
                <Button
                  type='primary'
                  size='large'
                  className={`loan_com_btn ${selectTog && 'active'}`}
                  onClick={() => handleSelectLoan(product.hasPremium)}
                  disabled={
                    product.hasPremium == 0 && manualDisable && selectTog == false
                  }
                >
                  {selectTog ? 'Selected' : 'Select'}
                </Button>
              )}
            </div>
          </div>
        </div>
        <ConfirmationModalInterest
          open={confirmModal}
          close={() => {
            setConfirmModal(false);
          }}
          updateHandler={setInterestChange}
        />
      </div>
    </div>











  );
};

export default LongBankCard;
